/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkCapturesRequest
 */
export interface LinkCapturesRequest {
    /**
     * 
     */
    manualCaptureId: string;
    /**
     * 
     */
    deviceCaptureId: string | null;
}

/**
 * Check if a given object implements the LinkCapturesRequest interface.
 */
export function instanceOfLinkCapturesRequest(value: object): value is LinkCapturesRequest {
    if ((!('manualCaptureId' in (value as Record<string, any>)) && !('manual_capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['manualCaptureId'] === undefined && (value as Record<string, any>)['manual_capture_id'] === undefined)) return false;
    if ((!('deviceCaptureId' in (value as Record<string, any>)) && !('device_capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceCaptureId'] === undefined && (value as Record<string, any>)['device_capture_id'] === undefined)) return false;
    return true;
}

export function LinkCapturesRequestFromJSON(json: any): LinkCapturesRequest {
    return LinkCapturesRequestFromJSONTyped(json, false);
}

export function LinkCapturesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkCapturesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'manualCaptureId': json['manual_capture_id'],
        'deviceCaptureId': json['device_capture_id'],
    };
}

export function LinkCapturesRequestToJSON(json: any): LinkCapturesRequest {
    return LinkCapturesRequestToJSONTyped(json, false);
}

export function LinkCapturesRequestToJSONTyped(value?: LinkCapturesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manual_capture_id': value['manualCaptureId'],
        'device_capture_id': value['deviceCaptureId'],
    };
}

